export const offerte = [
  {
    id: 1,
    prodotto: 'Kit Spezie Essenziali',
    descrizione: 'Set completo con 5 spezie biologiche più utilizzate',
    prezzoOriginale: '39.90',
    prezzoScontato: '29.90',
    sconto: '25',
    immagine: 'https://public.readdy.ai/ai/img_res/8174c5c78c620cc1b51772e02e13cb49.jpg',
    validoFino: '31 Marzo 2025'
  },
  {
    id: 2,
    prodotto: 'Box Biscotti Assortiti',
    descrizione: 'Confezione regalo con 6 varietà di biscotti biologici',
    prezzoOriginale: '34.90',
    prezzoScontato: '24.90',
    sconto: '29',
    immagine: 'https://readdy.ai/api/search-image?query=elegant%20gift%20box%20filled%20with%20assorted%20organic%20cookies%20and%20biscuits%20on%20white%20marble%20countertop%2C%20minimalist%20product%20photography%20with%20soft%20lighting%20and%20clean%20white%20background%2C%20premium%20packaging%20with%20variety%20of%20artisan%20biscuits%2C%20professional%20food%20styling&width=600&height=400&seq=offer2&orientation=landscape',
    validoFino: '15 Aprile 2025'
  },
  {
    id: 3,
    prodotto: 'Curcuma Premium + Zenzero',
    descrizione: 'Duo perfetto per tisane benefiche e ricette salutari',
    prezzoOriginale: '16.90',
    prezzoScontato: '12.90',
    sconto: '24',
    immagine: 'https://readdy.ai/api/search-image?query=two%20premium%20glass%20jars%20with%20organic%20turmeric%20and%20ginger%20powder%20on%20white%20marble%20surface%2C%20minimalist%20elegant%20product%20photography%20with%20soft%20natural%20lighting%20and%20clean%20white%20background%2C%20health%20focused%20spice%20duo%2C%20professional%20food%20styling&width=600&height=400&seq=offer3&orientation=landscape',
    validoFino: '30 Aprile 2025'
  }
];